/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mellow_Gray_Rat_ExpressInputs */

const es_mellow_gray_rat_express = /** @type {(inputs: Mellow_Gray_Rat_ExpressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscribirse`)
};

const gl_mellow_gray_rat_express = /** @type {(inputs: Mellow_Gray_Rat_ExpressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribirse`)
};

const en_mellow_gray_rat_express = /** @type {(inputs: Mellow_Gray_Rat_ExpressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Mellow_Gray_Rat_ExpressInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const mellow_gray_rat_express = /** @type {((inputs?: Mellow_Gray_Rat_ExpressInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mellow_Gray_Rat_ExpressInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_mellow_gray_rat_express(inputs)
	if (locale === "en") return en_mellow_gray_rat_express(inputs)
	return es_mellow_gray_rat_express(inputs)
});